define('plugin/membership/collection/ClientBookingMembershipCollection',['require','lib/collection/BaseCollection','plugin/membership/model/ClientMembershipModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var ClientMembershipModel = require('plugin/membership/model/ClientMembershipModel');

    /**
     * Membership collection
     *
     * @class MembershipCollection
     */
    return BaseCollection.extend({

        url: '/ext/membership/for-booking',
        model: ClientMembershipModel

    });

});
